/**
 * Auth Container Component
 *
 * Orchestrates auth forms (login, register).
 * No password required — passwordless flow only.
 */

import { useState } from 'react';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import styles from './Auth.module.css';

type AuthView = 'login' | 'register';

export function AuthContainer() {
  const [view, setView] = useState<AuthView>('login');

  return (
    <div className={styles.authContainer}>
      {view === 'login' && (
        <LoginForm
          onSwitchToRegister={() => setView('register')}
        />
      )}
      {view === 'register' && (
        <RegisterForm onSwitchToLogin={() => setView('login')} />
      )}
    </div>
  );
}
